import { TYPE_ENUM } from '../input-types';

export const id = 'deliveryStatus';
export const apiKey = 'deliveryStatus';
export const type = TYPE_ENUM;

export const deliveryStatus = {
  id,
  apiKey,
  type,
};
